import * as React from "react";
const SvgR5Robot20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 16,
        fill: "black",
        viewBox: "0 0 20 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v7.5h2V6h4v7a3 3 0 0 0 5.236 2h3.528A3 3 0 0 0 20 13V0H1Zm17 4V2H2v2h16Zm0 2H8v4.17A3 3 0 0 1 12 13h2a3 3 0 0 1 4-2.83V6ZM8 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgR5Robot20Px;
